import { Loader, Text } from '@kl/components-v6';
import { useTrackPageView } from 'features/tracking';
import { useAnnexDpa } from '../api/use-annex-dpa';
import { StyledLicenseAgreementsContainer, StyledTextContainer } from './styled';
import { NoLegalDocument } from './NoLegalDocument';

export const AnnexDpa = () => {
    useTrackPageView('landing > annex-dpa');

    const { document, isError, isFetching } = useAnnexDpa();

    if (isFetching) {
        return (
            <StyledLicenseAgreementsContainer height="100%">
                <Loader centered size="large" />
            </StyledLicenseAgreementsContainer>
        );
    }

    if (isError) {
        return (
            <StyledLicenseAgreementsContainer height="100%">
                <NoLegalDocument />
            </StyledLicenseAgreementsContainer>
        );
    }

    return (
        <StyledTextContainer padding="24px">
            {document ? (
                <Text color="secondary">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: document,
                        }}
                    />
                </Text>
            ) : (
                <NoLegalDocument />
            )}
        </StyledTextContainer>
    );
};
